module.exports = __webpack_public_path__ + "static/transparentTV-98176f5508ac90949341f6c4e5afc575.jpeg";